// État du dialogue, recalculé à chaque choix : morceaux, chevauchements et
// boutons actifs. Fonction pure, à partir des données lues une fois à
// l'ouverture du contrôle.

import { isNoop, resolvePieces } from './planSplit';
import { checkDates, findOverlaps } from './preflight';

/**
 * @param {Object} input
 * @param {Object} input.plan résultat de planSplit
 * @param {Object} input.context { replacement, slots, contract }
 * @param {Object} input.choices choix sur les trous
 * @param {Object} input.preflightData { cleaner, others } ou null si la
 *   lecture a échoué (care tranchera)
 * @param {boolean} input.create formulaire de création
 */
export const assess = ({ plan, context, choices, preflightData, create }) => {
  const { replacement, slots, contract } = context;
  const resolved = resolvePieces(plan, replacement, choices);
  const others = preflightData ? preflightData.others : [];

  // R tel que saisi : care le refusera s'il chevauche une autre affectation
  // du remplaçant, découpé ou non (checkAffectation à chaque écriture).
  const overlaps = findOverlaps(replacement, slots, others);

  // Morceaux proposés : chacun passe par checkAffectation (PATCH de R ou
  // createBundle).
  const pieceOverlaps = resolved
    ? resolved.some((piece) => {
        return findOverlaps(piece, slots, others).length > 0;
      })
    : false;
  const toCreate = resolved
    ? resolved.filter((piece) => {
        return create || !piece.original;
      })
    : [];
  const dateIssues =
    preflightData && toCreate.length
      ? checkDates(toCreate, { cleaner: preflightData.cleaner, contract })
      : [];
  const noop = isNoop(resolved, replacement);

  return {
    resolved,
    overlaps,
    pieceOverlaps,
    dateIssues,
    noop,
    canSplit:
      !!resolved &&
      resolved.length > 0 &&
      !noop &&
      !pieceOverlaps &&
      dateIssues.length === 0,
    canSaveAnyway: overlaps.length === 0,
  };
};

// Fin de la phrase sur les chevauchements, selon ce que « Découper » peut
// encore faire.
export const overlapWording = ({ overlaps, pieceOverlaps, resolved, plan }) => {
  const plural = overlaps.length > 1;
  const it = plural ? 'ces affectations' : 'cette affectation';
  if (!plan.pieces.length) {
    return {
      refusal: "care refusera l'enregistrement",
      advice: `Ouvrez ${it} pour comparer.`,
    };
  }
  if (!resolved) {
    return {
      refusal: "care refusera l'enregistrement tel quel",
      advice:
        '« Découper » sera vérifié une fois chaque jour orphelin tranché.',
    };
  }
  if (pieceOverlaps) {
    return {
      refusal: "care refusera l'enregistrement, avec ou sans découpage",
      advice: `La suite existe peut-être déjà : ouvrez ${it}.`,
    };
  }
  return {
    refusal: "care refusera l'enregistrement tel quel",
    advice: `Les morceaux proposés ne ${
      plural ? 'les' : 'la'
    } chevauchent pas : « Découper » reste possible.`,
  };
};
